"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.watchSUMOCEPSchedulerSaga = void 0;
const constants_1 = require("@/app/shared/constants");
const helpers_1 = require("@/app/shared/helpers");
const analyticsService_1 = require("@/app/shared/services/analyticsService");
const global_1 = require("@/app/shared/store/global");
const notifications_1 = require("@/app/shared/store/notifications");
const reduxUtils_1 = require("@/app/shared/store/reduxUtils");
const server_1 = require("@/app/SUMOCEP/server");
const effects_1 = require("redux-saga/effects");
const actions_1 = require("./actions");
const selectors_1 = require("./selectors");
const utils_1 = require("./utils");
function* getSchedulerDataSaga(action) {
    if (action.type !== actions_1.SUMOCEPSchedulerActionTypes.GET_SCHEDULER_DATA_REQUEST)
        return;
    try {
        const profile = yield (0, effects_1.call)(server_1.SalesForceServer.getUserProfile);
        if (!profile)
            throw new Error('Profile not found!');
        const hasBuffer = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectHasBuffer);
        const selectedTemplate = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectCEPSelectedTemplate);
        const serverPrefix = yield (0, effects_1.select)(global_1.globalSelectors.selectServerPrefix);
        const schedulerData = yield (0, effects_1.call)(server_1.SalesForceServer.getSchedulerData, profile, serverPrefix, selectedTemplate?.id);
        if (schedulerData) {
            yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.getSchedulerDataSuccess(schedulerData));
            if (profile.email) {
                analyticsService_1.analyticsService.identify(profile.email);
            }
            analyticsService_1.analyticsService.trackDialogOpened();
            if (schedulerData.templatesOptions?.length && schedulerData.templatesOptions[0] && !selectedTemplate?.id) {
                yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setCEPTemplateOptions(schedulerData.templatesOptions));
                const defaultTemplateId = helpers_1.Storage.Local.get(helpers_1.Storage.Key.DEFAULT_TEMPLATE_ID);
                const defaultTemplate = schedulerData.templatesOptions.find((template) => template.id === defaultTemplateId);
                const [fallbackTemplate = null] = schedulerData.templatesOptions;
                yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setCEPTemplate(defaultTemplate || fallbackTemplate));
                yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setDefaultTemplateId(defaultTemplateId || fallbackTemplate?.id || null));
                if (!hasBuffer) {
                    yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.updateBookingPageWhen({
                        beforeStartTime: helpers_1.bufferTimeConvert.fromNumberToString(schedulerData.userPreBufferTime || schedulerData.globalPreBufferTime),
                        afterEndTime: helpers_1.bufferTimeConvert.fromNumberToString(schedulerData.userPostBufferTime || schedulerData.globalPostBufferTime),
                    }));
                }
            }
            yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.getWorkspaceDataRequest());
            let host = schedulerData.users?.find((user) => user.id === profile.userId);
            const defaultHost = yield (0, effects_1.select)(global_1.globalSelectors.selectDefaultHost);
            if (!host) {
                const templateId = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectCEPSelectedTemplateId);
                const response = yield (0, effects_1.call)(server_1.SalesForceServer.getHost, {
                    hostId: profile.userId,
                    query: profile.email || undefined,
                    templateId,
                });
                yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.getHostSearchSuccess(response));
                host = response[0];
            }
            if (host && defaultHost === "ME" /* DefaultHost.ME */) {
                yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setHost(host));
            }
        }
    }
    catch (error) {
        yield (0, effects_1.call)(reduxUtils_1.handleServiceError, error, constants_1.TOAST_ERROR_ID.SCHEDULER_USER_DOES_NOT_HAVE_NECESSARY_PERMISSIONS);
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.getSchedulerDataFailure(error));
    }
}
function* getWorkspaceDataSaga(action) {
    if (action.type !== actions_1.SUMOCEPSchedulerActionTypes.GET_WORKSPACE_DATA_REQUEST)
        return;
    try {
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.getMembersRequest());
        const workspaceId = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectWorkspaceId);
        const schedulerParams = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectSchedulerParams);
        const isEngageAiLicense = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectIsEngageAiLicense);
        if (workspaceId !== helpers_1.Storage.Local.get(helpers_1.Storage.Key.SCHEDULER_WORKSPACE_ID)) {
            helpers_1.Storage.Local.set(helpers_1.Storage.Key.SCHEDULER_WORKSPACE_ID, workspaceId);
        }
    }
    catch (error) {
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.getWorkspaceDataFailure(error));
    }
}
function* setHostSaga(action) {
    if (action.type !== actions_1.SUMOCEPSchedulerActionTypes.SET_HOST)
        return;
    try {
        const videoConferenceType = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectHostDefaultVideoIntegration);
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.updateBookingPageWhere({ videoConferenceType }));
        if (action.payload !== null) {
            yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.getHostScheduleRequest());
            yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.getLocationsRequest());
        }
    }
    catch (error) {
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.getHostScheduleFailure(error));
    }
}
function* getHostScheduleSaga(action) {
    if (action.type !== actions_1.SUMOCEPSchedulerActionTypes.GET_HOST_SCHEDULE_REQUEST)
        return;
    try {
        const host = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectHost);
        if (host) {
            const hostMeetings = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectHostMeetings);
            const params = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectHostScheduleRequest);
            const template = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectCEPSelectedTemplate);
            const serviceDurations = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectServiceDurations);
            const response = yield (0, effects_1.call)(server_1.SalesForceServer.getHostSchedule, params, hostMeetings, template, serviceDurations);
            const serviceLimitReached = response.serviceLimitReached ?? false;
            yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setHostLimitWarning(serviceLimitReached));
            yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.getHostScheduleSuccess(response));
        }
        else {
            yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.getHostScheduleSuccess(null));
        }
    }
    catch (error) {
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.getHostScheduleFailure(error));
    }
}
function* getRoomAndResourcesSaga(action) {
    if (action.type !== actions_1.SUMOCEPSchedulerActionTypes.GET_ROOM_AND_RESOURCES_REQUEST)
        return;
    try {
        const templateId = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectCEPSelectedTemplateId);
        const locationId = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectLocation);
        const serverPrefix = yield (0, effects_1.select)(global_1.globalSelectors.selectServerPrefix);
        const response = yield (0, effects_1.call)(server_1.SalesForceServer.getRoomAndResources, { locationId, templateId }, serverPrefix);
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.getRoomAndResourcesSuccess(response));
        // yield put(schedulerActions.updateBookingPageWhere({ locationRoom: response.rooms[0] }));
    }
    catch (error) {
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.getRoomAndResourcesFailure(error));
    }
}
function* upsertInboxBookingPageSaga(action) {
    if (action.type !== actions_1.SUMOCEPSchedulerActionTypes.SCHEDULER_UPSERT_INBOX_BOOKING_PAGE_REQUEST)
        return;
    try {
        const bookingPage = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectFinalBookingPage);
        const calendarParameters = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectPayloadAvailabilityCalendarParameters);
        const hostScheduleAvailability = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectHostAvailability);
        const hostScheduleMeetings = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectHostMeetings);
        const availability = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectFilteredAvailability);
        const availabilityCustom = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectAvailabilityCustom);
        const template = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectCEPSelectedTemplate);
        const serviceDurations = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectServiceDurations);
        const spots = yield (0, effects_1.call)(server_1.SalesForceServer.getSlots, {
            bookingPage,
            calendarParameters,
            hostScheduleAvailability,
            hostScheduleMeetings,
            availability,
            availabilityCustom,
            template,
        });
        const response = yield (0, effects_1.call)(server_1.SalesForceServer.schedulerUpsertInboxBookingPage, {
            bookingPage,
            spots,
            startTime: calendarParameters.start.getTime(),
            endTime: calendarParameters.end.getTime(),
            dayLimit: constants_1.INBOX_DAY_LIMIT,
            spotLimit: constants_1.INBOX_SPOTS_LIMIT,
            timeZone: calendarParameters.timeZone,
            serviceDurations,
        });
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.schedulerUpsertInboxBookingPageSuccess());
        // insert title, guests and link to email
        const { composeViewId } = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectSchedulerParams);
        const upsertAction = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectUpsertAction);
        const subject = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectCustomName);
        const mainGuest = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectMainGuest);
        const guests = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectGuests);
        const duration = bookingPage.when?.duration;
        const bookingPageId = bookingPage?.id;
        const shortLink = response?.inviteLink;
        const payload = {
            guests: [mainGuest, ...guests].filter((member) => Boolean(member?.email)),
            subject,
            composeViewId,
        };
        yield (0, effects_1.call)(helpers_1.ExtensionRuntime.sendMessage, {
            target: constants_1.MessageTarget.SCHEDULER_DIALOG,
            type: constants_1.RegularMessage.SCHEDULER_INSERT_GUESTS_AND_SUBJECT,
            payload,
        });
        analyticsService_1.analyticsService.trackGuestsInserted();
        if (upsertAction === constants_1.UpsertAction.COPY && shortLink) {
            const payload = { shortLink, composeViewId };
            yield (0, effects_1.call)(helpers_1.ExtensionRuntime.sendMessage, {
                target: constants_1.MessageTarget.SCHEDULER_DIALOG,
                type: constants_1.RegularMessage.SCHEDULER_COPY_LINK,
                payload,
            });
            analyticsService_1.analyticsService.trackLinkCopied();
        }
        else if (upsertAction === constants_1.UpsertAction.INSERT && spots && duration && shortLink) {
            const payload = {
                guests,
                spots,
                duration: { count: duration.count || 0, timeUnit: duration.timeUnit === constants_1.TimeUnit.HOUR ? constants_1.TimeUnit.HOUR : constants_1.TimeUnit.MINUTE },
                bookingPageId,
                composeViewId,
                spotUrl: shortLink,
                querySpotKey: 'datetime',
                querySpotFormat: 'string',
            };
            yield (0, effects_1.call)(helpers_1.ExtensionRuntime.sendMessage, {
                target: constants_1.MessageTarget.SCHEDULER_DIALOG,
                type: constants_1.RegularMessage.SCHEDULER_INSERT_SPOTS,
                payload,
            });
            analyticsService_1.analyticsService.trackSpotsInserted();
        }
    }
    catch (error) {
        if (error instanceof Error) {
            yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.schedulerUpsertInboxBookingPageFailure(error.message));
        }
        yield (0, effects_1.call)(reduxUtils_1.handleServiceError, error, constants_1.TOAST_ERROR_ID.SCHEDULER_CREATE_BOOKING_PAGE_ERROR);
    }
}
function* bookPageSaga(action) {
    if (action.type !== actions_1.SUMOCEPSchedulerActionTypes.SCHEDULER_BOOK_PAGE_REQUEST)
        return;
    try {
        const bookAction = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectBookAction);
        const bookingPage = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectFinalBookingPage);
        const calendarParameters = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectPayloadAvailabilityCalendarParameters);
        const hostScheduleAvailability = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectHostAvailability);
        const hostScheduleMeetings = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectHostMeetings);
        const availability = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectFilteredAvailability);
        const availabilityCustom = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectAvailabilityCustom);
        const template = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectCEPSelectedTemplate);
        const serviceDurations = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectServiceDurations);
        const spots = yield (0, effects_1.call)(server_1.SalesForceServer.getSlots, {
            bookingPage,
            calendarParameters,
            hostScheduleAvailability,
            hostScheduleMeetings,
            availability,
            availabilityCustom,
            template,
        });
        yield (0, effects_1.call)(server_1.SalesForceServer.schedulerLinkInboxBookingPage, {
            bookingPage,
            spots,
            startTime: calendarParameters.start.getTime(),
            endTime: calendarParameters.end.getTime(),
            dayLimit: constants_1.INBOX_DAY_LIMIT,
            spotLimit: constants_1.INBOX_SPOTS_LIMIT,
            timeZone: calendarParameters.timeZone,
            serviceDurations,
        });
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.schedulerBookPageSuccess());
        if (bookAction === constants_1.BookAction.BOOK_CLOSED) {
            yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setBookPageSuccessStatus(true));
            yield (0, effects_1.delay)(constants_1.TIME_DELAY_CLOSE_DIALOG);
            yield (0, effects_1.call)(helpers_1.ExtensionRuntime.sendMessage, { target: constants_1.MessageTarget.SCHEDULER_DIALOG, type: constants_1.RegularMessage.SCHEDULER_DIALOG_CLOSE });
            analyticsService_1.analyticsService.trackDialogClosed();
        }
        else {
            yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.getHostScheduleRequest());
            yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setAvailabilityCustom([]));
            yield (0, effects_1.put)(notifications_1.notificationsActions.showToast({ id: constants_1.TOAST_ERROR_ID.SCHEDULER_BOOKED_SUCCESS_MESSAGE }));
        }
    }
    catch (error) {
        if (error instanceof Error) {
            yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.schedulerBookPageFailure(error.message));
        }
        yield (0, effects_1.call)(reduxUtils_1.handleServiceError, error, constants_1.TOAST_ERROR_ID.SCHEDULER_CREATE_BOOKING_PAGE_ERROR);
    }
}
function* getAttendeesRequestSaga(action) {
    if (action.type !== actions_1.SUMOCEPSchedulerActionTypes.GET_ATTENDEES_SEARCH_REQUEST)
        return;
    try {
        const templateId = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectCEPSelectedTemplateId);
        const response = yield (0, effects_1.call)(server_1.SalesForceServer.getAttendees, { templateId, query: action.payload });
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.getAttendeesSearchSuccess(response));
    }
    catch (error) {
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.getAttendeesSearchFailure(error.message));
    }
}
function* getHostRequestSaga(action) {
    if (action.type !== actions_1.SUMOCEPSchedulerActionTypes.GET_HOST_SEARCH_REQUEST)
        return;
    try {
        const templateId = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectCEPSelectedTemplateId);
        const response = yield (0, effects_1.call)(server_1.SalesForceServer.getHost, {
            query: action.payload,
            templateId
        });
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.getHostSearchSuccess(response));
    }
    catch (error) {
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.getHostSearchFailure(error.message));
    }
}
function* getMembersRequestSaga(action) {
    if (action.type !== actions_1.SUMOCEPSchedulerActionTypes.GET_MEMBERS_REQUEST)
        return;
    try {
        const schedulerParams = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectSchedulerParams);
        const templateId = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectCEPSelectedTemplateId);
        const { TO = [], CC = [], BCC = [] } = schedulerParams.recipientsEmails || {};
        const contacts = [...TO, ...CC, ...BCC];
        if (!contacts.length) {
            yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setMainGuest(null));
            yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setGuests([]));
            return;
        }
        const emails = [...new Set(contacts.map((c) => c.emailAddress).filter(Boolean))];
        const response = yield (0, effects_1.call)(server_1.SalesForceServer.inboxSearchParticipantsCreate, { templateId, emails });
        if (response.data?.results?.length) {
            const { mainGuest, guests } = (0, utils_1.processSearchParticipantsResponse)(contacts, response.data.results);
            yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setMainGuest(mainGuest));
            yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setGuests(guests));
        }
        else {
            const schedulerData = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectSchedulerData);
            const { mainGuest, guests } = (0, utils_1.processMembersResponse)(schedulerData.users, schedulerParams);
            yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setMainGuest(mainGuest));
            yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setGuests(guests));
        }
    }
    catch (error) {
        console.log(`🚀 ~ getMembersRequestSaga ~ error:`, error);
    }
}
function* getLocationsRequestSaga(action) {
    if (action.type !== actions_1.SUMOCEPSchedulerActionTypes.GET_LOCATIONS_REQUEST)
        return;
    try {
        const templateId = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectCEPSelectedTemplateId);
        const host = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectHost);
        const serverPrefix = yield (0, effects_1.select)(global_1.globalSelectors.selectServerPrefix);
        let locationOptions = [];
        if (host?.id) {
            locationOptions = yield (0, effects_1.call)(server_1.SalesForceServer.getLocations, { hostId: host.id, templateId }, serverPrefix);
        }
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setLocationItems(locationOptions));
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.getLocationsSuccess());
    }
    catch (error) {
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.getLocationsFailure(error));
    }
}
function* getServicesSearchRequestSaga(action) {
    if (action.type !== actions_1.SUMOCEPSchedulerActionTypes.GET_SERVICES_SEARCH_REQUEST)
        return;
    try {
        const host = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectHost);
        const hostId = host?.id || undefined;
        const templateId = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectCEPSelectedTemplateId);
        const serverPrefix = yield (0, effects_1.select)(global_1.globalSelectors.selectServerPrefix);
        const response = yield (0, effects_1.call)(server_1.SalesForceServer.getServices, { query: action.payload, templateId, hostId }, serverPrefix);
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.getServicesSearchSuccess(response));
    }
    catch (error) {
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.getServicesSearchFailure(error));
    }
}
function* setServiceSelectionSaga(action) {
    if (action.type !== actions_1.SUMOCEPSchedulerActionTypes.SET_SERVICE_SELECTION)
        return;
    try {
        const customName = action.payload;
        const appointmentTypes = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectAppointmentTypes);
        const schedulerData = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectSchedulerData);
        const service = appointmentTypes.find((item) => item.label && item.label.toLowerCase() === customName.toLowerCase());
        const serviceIds = service?.value ? [service.value] : [];
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.updateBookingPageWhat({ customName, serviceIds }));
        if (!service || !serviceIds.length)
            return;
        const { beforeStartTime: serviceBeforeStartTime, afterEndTime: serviceAfterEndTime } = service;
        const beforeStartTime = schedulerData?.userPreBufferTime || schedulerData?.globalPreBufferTime
            ? helpers_1.bufferTimeConvert.fromNumberToString(schedulerData?.userPreBufferTime || schedulerData?.globalPreBufferTime)
            : serviceBeforeStartTime;
        const afterEndTime = schedulerData?.userPostBufferTime || schedulerData?.globalPostBufferTime
            ? helpers_1.bufferTimeConvert.fromNumberToString(schedulerData?.userPostBufferTime || schedulerData?.globalPostBufferTime)
            : serviceAfterEndTime;
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setHasBuffer(Boolean(beforeStartTime || afterEndTime)));
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.updateBookingPageWhen({ beforeStartTime, afterEndTime }));
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setServiceSelectionSuccess());
    }
    catch (error) {
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setServiceSelectionFailure(error));
    }
}
function* setMultiServiceSelectionSaga(action) {
    if (action.type !== actions_1.SUMOCEPSchedulerActionTypes.SET_MULTI_SERVICE_SELECTION)
        return;
    const serviceIds = action.payload;
    const appointmentTypes = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectAppointmentTypes);
    if (!serviceIds.length) {
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.updateBookingPageWhat({ customName: '' }));
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setServiceDurationMinutes(null));
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setServiceDurations(null));
        return;
    }
    try {
        const locationType = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectLocationType);
        const host = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectHost);
        const templateId = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectCEPSelectedTemplateId);
        const serviceData = yield (0, effects_1.call)(server_1.SalesForceServer.getServiceData, {
            serviceIds,
            locationType: (0, utils_1.convertToServiceDataRequestLocationTypeEnum)(locationType),
            attendeeIds: host?.id ? [host.id] : undefined,
            templateId,
        });
        if (serviceData?.durations && Object.keys(serviceData.durations).length > 0) {
            const validIds = serviceIds.filter((id) => id in serviceData.durations);
            if (validIds.length !== serviceIds.length) {
                const removedNames = appointmentTypes
                    .filter((s) => serviceIds.includes(s.value) && !validIds.includes(s.value))
                    .map((s) => s.label);
                if (removedNames.length) {
                    const locationType = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectLocationType);
                    const locationLabel = locationType ?? 'selected location';
                    const warning = `${removedNames.join(', ')} ${removedNames.length === 1 ? 'is' : 'are'} not available for ${locationLabel} and will not be included in this appointment.`;
                    yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setServiceLocationWarning(warning));
                }
                yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setMultiServiceSelection(validIds));
                return;
            }
        }
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setServiceDurations(serviceData?.durations ?? null));
        if (serviceData?.duration) {
            yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.updateBookingPageWhen({
                duration: { count: serviceData.duration, timeUnit: constants_1.TimeUnit.MINUTE },
            }));
        }
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setServiceDurationMinutes(serviceData?.duration ?? null));
        const schedulerData = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectSchedulerData);
        const beforeStartTime = schedulerData?.userPreBufferTime || schedulerData?.globalPreBufferTime
            ? helpers_1.bufferTimeConvert.fromNumberToString(schedulerData?.userPreBufferTime || schedulerData?.globalPreBufferTime)
            : helpers_1.bufferTimeConvert.fromNumberToString(serviceData?.bufferTimePre);
        const afterEndTime = schedulerData?.userPostBufferTime || schedulerData?.globalPostBufferTime
            ? helpers_1.bufferTimeConvert.fromNumberToString(schedulerData?.userPostBufferTime || schedulerData?.globalPostBufferTime)
            : helpers_1.bufferTimeConvert.fromNumberToString(serviceData?.bufferTimePost);
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setHasBuffer(Boolean(beforeStartTime || afterEndTime)));
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.updateBookingPageWhen({ beforeStartTime, afterEndTime }));
        const customName = serviceData?.name || appointmentTypes
            .filter((s) => serviceIds.includes(s.value))
            .map((s) => s.label)
            .join(', ');
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.updateBookingPageWhat({ customName }));
    }
    catch (error) {
        const customName = appointmentTypes
            .filter((s) => serviceIds.includes(s.value))
            .map((s) => s.label)
            .join(', ');
        yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.updateBookingPageWhat({ customName }));
    }
}
function* locationTypeChangeSaga(action) {
    if (action.type !== actions_1.SUMOCEPSchedulerActionTypes.UPDATE_BOOKING_PAGE_WHERE)
        return;
    // Only react when locationTypes actually changes (not video type, phone, etc.)
    if (!action.payload?.locationTypes)
        return;
    const serviceIds = yield (0, effects_1.select)(selectors_1.schedulerSelectors.selectSelectedServiceIds);
    if (!serviceIds.length)
        return;
    // Re-validate services against new location type
    yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.setMultiServiceSelection(serviceIds));
}
function* watchSUMOCEPSchedulerSaga() {
    yield (0, effects_1.takeLatest)(actions_1.SUMOCEPSchedulerActionTypes.GET_SCHEDULER_DATA_REQUEST, getSchedulerDataSaga);
    yield (0, effects_1.takeLatest)(actions_1.SUMOCEPSchedulerActionTypes.GET_WORKSPACE_DATA_REQUEST, getWorkspaceDataSaga);
    yield (0, effects_1.takeLatest)(actions_1.SUMOCEPSchedulerActionTypes.SET_HOST, setHostSaga);
    yield (0, effects_1.takeLatest)(actions_1.SUMOCEPSchedulerActionTypes.GET_HOST_SCHEDULE_REQUEST, getHostScheduleSaga);
    yield (0, effects_1.takeLatest)(actions_1.SUMOCEPSchedulerActionTypes.GET_ROOM_AND_RESOURCES_REQUEST, getRoomAndResourcesSaga);
    yield (0, effects_1.takeLatest)(actions_1.SUMOCEPSchedulerActionTypes.SCHEDULER_UPSERT_INBOX_BOOKING_PAGE_REQUEST, upsertInboxBookingPageSaga);
    yield (0, effects_1.takeLatest)(actions_1.SUMOCEPSchedulerActionTypes.SCHEDULER_BOOK_PAGE_REQUEST, bookPageSaga);
    yield (0, effects_1.takeLatest)(actions_1.SUMOCEPSchedulerActionTypes.GET_ATTENDEES_SEARCH_REQUEST, getAttendeesRequestSaga);
    yield (0, effects_1.takeLatest)(actions_1.SUMOCEPSchedulerActionTypes.GET_HOST_SEARCH_REQUEST, getHostRequestSaga);
    yield (0, effects_1.takeLatest)(actions_1.SUMOCEPSchedulerActionTypes.GET_MEMBERS_REQUEST, getMembersRequestSaga);
    yield (0, effects_1.takeLatest)(actions_1.SUMOCEPSchedulerActionTypes.GET_LOCATIONS_REQUEST, getLocationsRequestSaga);
    yield (0, effects_1.takeLatest)(actions_1.SUMOCEPSchedulerActionTypes.GET_SERVICES_SEARCH_REQUEST, getServicesSearchRequestSaga);
    yield (0, effects_1.takeLatest)(actions_1.SUMOCEPSchedulerActionTypes.SET_SERVICE_SELECTION, setServiceSelectionSaga);
    yield (0, effects_1.takeLatest)(actions_1.SUMOCEPSchedulerActionTypes.SET_MULTI_SERVICE_SELECTION, setMultiServiceSelectionSaga);
    yield (0, effects_1.takeLatest)(actions_1.SUMOCEPSchedulerActionTypes.UPDATE_BOOKING_PAGE_WHERE, locationTypeChangeSaga);
}
exports.watchSUMOCEPSchedulerSaga = watchSUMOCEPSchedulerSaga;
